<template>
  <div>
    <button
        class="button"
        :style="buttonStyle"
        :disabled="disabled"
        @click="$emit('click')"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ApproveButton",
  props: {
    buttonText: {
      type: String,
      default: "Approve all", // Default button text
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonColor: {
      type: String,
      default: "#000", // Default background color
    },
    hoverColor: {
      type: String,
      default: "#007bff", // Default hover background color
    },
    hoverTextColor: {
      type: String,
      default: "#fff", // Default hover text color
    },
  },
  computed: {
    buttonStyle() {
      return {
        "--bg": this.buttonColor,
        "--hover-bg": this.hoverColor,
        "--hover-text": this.hoverTextColor,
      };
    },
  },
};
</script>

<style scoped>
.button {
  --bg: #000;
  --hover-bg: #ff90e8;
  --hover-text: #000;
  color: #fff;
  cursor: pointer;
  border: 1px solid var(--bg);
  border-radius: 4px;
  padding: 0.8em 2em;
  background: var(--bg);
  transition: 0.2s;
  margin: 5px;
  margin-bottom: 10px;
}

.button:hover {
  color: var(--hover-text);
  transform: translate(-0.25rem, -0.25rem);
  background: var(--hover-bg);
  box-shadow: 0.25rem 0.25rem var(--bg);
}

.button:active {
  transform: translate(0);
  box-shadow: none;
}

.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.button:disabled:hover {
  color: #fff;
  transform: none;
  background: var(--bg);
  box-shadow: none;
}
</style>
